var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamsStoreDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.174,
    y1: 1.067,
    x2: 0.826,
    y2: -0.063,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a62c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4d55bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940ab"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teams_-_Color",
    "data-name": "Teams - Color",
    transform: "translate(-907 -620)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Microsoft_Office_Teams__2018_present_",
    "data-name": "Microsoft_Office_Teams_(2018\\u2013present)",
    transform: "translate(907 620.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M1503.492,777.5h3.616a.618.618,0,0,1,.618.619h0v3.294a2.274,2.274,0,0,1-2.273,2.274h-.011a2.274,2.274,0,0,1-2.274-2.273h0v-3.589a.323.323,0,0,1,.323-.323Z",
    transform: "translate(-1493.727 -772.616)",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 1.465,
    cy: 1.465,
    r: 1.465,
    transform: "translate(10.744 1.302)",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 2.116,
    cy: 2.116,
    r: 2.116,
    transform: "translate(5.535 0)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M628.406,777.5h-5.969a.612.612,0,0,0-.6.626v3.757a3.585,3.585,0,1,0,7.163,0v-3.757A.612.612,0,0,0,628.406,777.5Z",
    transform: "translate(-617.933 -772.616)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M625.879,777.5v5.265a.6.6,0,0,1-.371.55.575.575,0,0,1-.225.046h-3.025c-.042-.108-.081-.215-.114-.326a3.967,3.967,0,0,1-.173-1.152v-3.757a.611.611,0,0,1,.6-.625Z",
    transform: "translate(-618.065 -772.616)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M625.554,777.5v5.59a.577.577,0,0,1-.046.225.6.6,0,0,1-.55.371h-2.546c-.055-.108-.107-.215-.153-.326a3.222,3.222,0,0,1-.114-.326,3.967,3.967,0,0,1-.173-1.152v-3.757a.611.611,0,0,1,.6-.625Z",
    transform: "translate(-618.065 -772.616)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M625.558,777.5v4.939a.6.6,0,0,1-.6.6h-2.813a3.963,3.963,0,0,1-.173-1.152v-3.757a.611.611,0,0,1,.6-.625Z",
    transform: "translate(-618.07 -772.616)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M625.229,777.5v4.939a.6.6,0,0,1-.6.6h-2.487a3.967,3.967,0,0,1-.173-1.152v-3.757a.611.611,0,0,1,.6-.625Z",
    transform: "translate(-618.066 -772.616)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M892.717,415.264v1.026c-.055,0-.107.006-.163.006s-.107,0-.163-.006a1.785,1.785,0,0,1-.326-.052,2.116,2.116,0,0,1-1.465-1.244,1.8,1.8,0,0,1-.1-.326h1.625A.6.6,0,0,1,892.717,415.264Z",
    transform: "translate(-884.903 -412.063)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M908.878,467.1v.7a1.786,1.786,0,0,1-.326-.052,2.116,2.116,0,0,1-1.465-1.244h1.195A.6.6,0,0,1,908.878,467.1Z",
    transform: "translate(-901.389 -463.571)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M908.878,467.1v.7a1.786,1.786,0,0,1-.326-.052,2.116,2.116,0,0,1-1.465-1.244h1.195A.6.6,0,0,1,908.878,467.1Z",
    transform: "translate(-901.389 -463.571)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M908.545,467.1v.648a2.116,2.116,0,0,1-1.465-1.244h.869A.6.6,0,0,1,908.545,467.1Z",
    transform: "translate(-901.382 -463.57)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M.6,466.5H6.566a.6.6,0,0,1,.6.6v5.969a.6.6,0,0,1-.6.6H.6a.6.6,0,0,1-.6-.6V467.1A.6.6,0,0,1,.6,466.5Z",
    transform: "translate(0 -463.57)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M323.264,728.474h-1.193v3.249h-.76v-3.249h-1.188v-.63h3.141Z",
    transform: "translate(-318.112 -723.272)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_970",
    "data-name": "Rectangle 970",
    width: 14,
    height: 14,
    transform: "translate(907 620)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsStoreDarkIcon);
export default __webpack_public_path__ + "static/media/teams-store-dark-icon.640cab4ae58e27097a13fde2ed2dd791.svg";
export { ForwardRef as ReactComponent };